<template>
  <div class="card card-content">
    <h6>Other Investigation</h6>
    <form>
      <div class="row">
        <div class="input-field col s12">
          <div class="switch">
            <label>
              Not Done
              <input type="checkbox" @click="switchChange" />
              <span class="lever"></span>
              Done
            </label>
          </div>
        </div>
        <div class="input-field col s12">
          <span>Investigation Date</span>
          <input
            type="text"
            placeholder="YYYY-MM-DD"
            v-model.lazy="date"
            class="datepicker"
            :disabled="!done"
            readonly
          />
        </div>
        <div class="input-field col s12" v-show="done">
          <span>Investigation Name</span>
          <input type="text" v-model.lazy="name" :disabled="!done" />
        </div>
        <div class="input-field col s12" v-show="done">
          <span>Investigation Result</span>
          <input type="text" v-model.lazy="result" :disabled="!done" />
        </div>
        <div class="input-field col s12" v-show="done">
          <span>AFB Seen/Not Seen</span>
          <select v-model="seen_not_seen">
            <option value="" disabled selected>Choose your option</option>
            <option value="seen">Seen</option>
            <option value="not seen">Not Seen</option>
          </select>
        </div>

        <div class="row center">
          <button
            type="button"
            class="btn blue darken-3"
            @click="submit"
            :disabled="updateloading"
            v-if="buttonpass"
          >
            Edit
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "AddFNAC",
  data() {
    return {
      done: false,
      date: "",
      result: "",
    };
  },
  mounted() {
    var elems = document.querySelectorAll("select");
    var instances = M.FormSelect.init(elems, {});

    var elems = document.querySelectorAll(".datepicker");
    var instances = M.Datepicker.init(elems, {
      format: "yyyy-mm-dd",
      showClearBtn: true,
    });
  },
  watch: {},
  methods: {
    switchChange() {
      this.done = this.done == 0 ? 1 : 0;
      if (this.done == 1) {
        localStorage.setItem("current_data", "changed");
      } else {
        localStorage.setItem("current_data", null);
      }
    },

    submit() {
      var data = {
        done: this.done,
        date: null,
        name: null,
        result: null,
        seen_not_seen: null,
      };

      if (this.done) {
        data.date = this.date;
        data.result = this.result;
        data.name = this.name;
        data.seen_not_seen = this.seen_not_seen;
      }

      data.id = this.patient.id;

      this.$store.dispatch("submitOtherInvestigation", data);
    },
  },
  components: {},
  watch: {
    updateloading(newVal) {
      if (!newVal) {
        location.reload();
      }
    },
  },
  computed: {
    patient() {
      return this.$store.getters.patient;
    },

    buttonpass() {
      if (this.done) {
        if (this.result && this.date && this.name) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    updateloading() {
      return this.$store.getters.updateloading;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fill {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 5px;
}

.fill .card {
  padding: 20px;
}
</style>
